// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import FirefoxFilledSvg from "@fishx/icons-svg/es/asn/FirefoxFilled";
import FishxIcon from '../components/FishxIcon';

var FirefoxFilled = function FirefoxFilled(props, ref) {
  return React.createElement(FishxIcon, Object.assign({}, props, {
    ref: ref,
    icon: FirefoxFilledSvg
  }));
};

FirefoxFilled.displayName = 'FirefoxFilled';
export default React.forwardRef(FirefoxFilled);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons/es/icons/FirefoxFilled.js
// module id = 2779
// module chunks = 0